export class DeviceModel {
    uuid: string;
    phoneNumber: string;
    constructor(uuid: string = "", phoneNumber: string = "") {
        this.uuid = uuid;
        this.phoneNumber = phoneNumber;
    }
}